/*
 * Functions to send email.
 */
import makeRequest from "../api/apiRequest";
import { constructUrl } from "./apiConfig";
import { EmailToUserResponseSchema } from "../types/email";
import { validateApiResponse } from "../types/validators";

export const emailToUser = async (
  userEmail: string,
  sessionId: string
): Promise<{ message?: string; error?: string }> => {
  const endpoint = "/sendmessage";
  const url = constructUrl(endpoint);
  const response = await makeRequest(
    url,
    "POST",
    { user: userEmail, sessionid: sessionId },
    {},
    {}
  );
  console.log(`emailToUser: response.errorType= ${response.errorType}`);

  if (response.errorType === 0) {
    try {
      const validated = validateApiResponse(
        EmailToUserResponseSchema.shape.data,
        { errorType: 0, data: { message: (response.data as any).message } },
        'emailToUser'
      );
      return { message: validated.message };
    } catch (err) {
      console.error('Validation failed for emailToUser:', err);
      return { message: (response.data as any).message };
    }
  } else {
    return { error: response.errorMessage };
  }
};

const emailToManager = async (
  managerEmail: string,
  userId: string,
  flow: string
): Promise<{ message?: string; error?: string }> => {
  const endpoint = "/manager_approval";
  const url = constructUrl(endpoint);
  console.log(
    `emailToManager: url= ${url}, manager_email= ${managerEmail}, userid= ${userId}, flow= ${flow}`
  );
  const response = await makeRequest(
    url,
    "POST",
    { manager_email: managerEmail, userid: userId, flow: flow },
    {},
    {}
  );
  console.log(`emailToManager: response.errorType= ${response.errorType}`);

  if (response.errorType === 0) {
    return { message: (response.data as any).message };
  } else {
    return { error: response.errorMessage };
  }
};

export const removeExternalEmail = async (userId: string): Promise<{
  errorMsg: string | null;
}> => {
  const endpoint = "/external_email";
  const url = constructUrl(endpoint);
  console.log(`removeExternalEmail: url= ${url}, userid= ${userId}`);
  const response = await makeRequest(url, "DELETE", { userid: userId }, {}, {});
  console.log(`removeExternalEmail: response.errorType= ${response.errorType}`);

  if (response.errorType === 0) {
    return {
      errorMsg: null,
    };
  } else {
    return { errorMsg: response.errorMessage };
  }
};

export const emailToManagerIdVerify = async (
  managerEmail: string,
  userId: string
): Promise<{ message?: string; error?: string }> => {
  return await emailToManager(managerEmail, userId, "password_reset");
};

export const emailToManager2ndEmail = async (
  managerEmail: string,
  userId: string
): Promise<{ message?: string; error?: string }> => {
  return await emailToManager(managerEmail, userId, "add_ext_email");
};

export default emailToUser;
